import React from 'react';
import './Textarea.css';

const Textarea = ({ placeholder, value, onChange, rows = 4, className = '', ...props }) => {
  return (
    <textarea
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={rows}
      className={`textarea ${className}`}
      {...props}
    />
  );
};

export default Textarea; 